<script>
  import IconLabel from "../molecules/IconLabel.vue";
  import Avatar from "@/common/Avatar.vue";

  export default {
    name: "StatusHistoryCard",
    props: ["date", "user", "reason", "tags", "description", "role", "startDate", "endDate", "variant", "optionsDisabled", "isExpanded", "eventType", "canExpand", "type", "isFuture"],
    components: {
      Avatar,
      IconLabel,
    },
    data() {
      return {
        timeoutId: null,
        userDictionary: {
          system: "Sistema",
        },
      };
    },
    computed: {
      isCompact() {
        return this.variant === "compact";
      },
    },
    methods: {
      formatDateToLocale(date, showTime = true) {
        if (!date) return "";
        const showDate = new Date(date).getFullYear() !== new Date().getFullYear();
        const formatted = this.formatDate(date, {
          day: "numeric",
          month: "long",
          year: showDate ? "numeric" : undefined,
          hour: showTime ? "2-digit" : undefined,
          minute: showTime ? "2-digit" : undefined,
          hourCycle: showTime ? "h12" : undefined,
        });

        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
      },
      formatDate(date, options = { timezone: "America/Bogota", year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h12" }) {
        if (!date) return "";
        return new Date(date).toLocaleDateString("es-CO", options);
      },
      handleClick() {
        this.$emit("toggle");
      },
      beforeEnter(el) {
        el.style.height = "0";
        el.style.opacity = "0";
      },
      enter(el, done) {
        clearTimeout(this.timeoutId);
        const height = el.scrollHeight + 50 + "px";
        el.style.transition = "all 0.3s ease";
        requestAnimationFrame(() => {
          el.style.height = height;
          el.style.opacity = "1";
        });
        this.timeoutId = setTimeout(() => {
          el.style.height = "auto";
          done();
        }, 300);
      },
      leave(el, done) {
        clearTimeout(this.timeoutId);

        el.style.height = el.scrollHeight + "px";
        el.style.opacity = "1";

        requestAnimationFrame(() => {
          el.style.transition = "all 0.3s ease";
          el.style.height = "0";
          el.style.opacity = "0";
        });
        this.timeoutId = setTimeout(() => done(), 300);
      },
    },
  };
</script>

<template>
  <div :class="['statusHistoryCard', { compact: isCompact, 'statusHistoryCard--green': isCompact && eventType === 'Activación', 'statusHistoryCard--future': eventType === 'Licencia' }]">
    <div :class="`statusHistoryCard__header`">
      <template v-if="isCompact">
        <div class="statusHistoryCard__userRow">
          <div v-if="user === 'system'" class="statusHistoryCard__userIcon">
            <iconic name="gearIcon" />
          </div>
          <Avatar :user="user" class="statusHistoryCard__avatar" v-else />
          <p class="statusHistoryCard__userText">
            Cambio realizado por {{ user === "system" ? "el" : "" }} <strong>{{ user.user || userDictionary[user] }}</strong>
          </p>
        </div>
      </template>
      <template v-else>
        <IconLabel
          icon="clockIcon"
          :text="formatDateToLocale(isFuture ? startDate : date, isFuture ? false : true)"
          :isDate="true"
          :title="`${isFuture ? 'Próxima ' : ''}${isFuture ? 'licencia' : eventType} el`" />
        <div class="statusHistoryCard__userContainer">
          <p class="statusHistoryCard__user">
            por {{ user === "system" ? "el" : "" }} <strong>{{ user.user || userDictionary[user] }}</strong>
          </p>
          <div :class="['statusHistoryCard__iconButton', { 'statusHistoryCard__iconButton--rotated': isExpanded }]" @click="handleClick()" v-if="canExpand">
            <iconic name="downArrow" />
          </div>
        </div>
      </template>
    </div>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div class="statusHistoryCard__content" v-if="isExpanded || isCompact">
        <div class="statusHistoryCard__contentContainer">
          <IconLabel v-if="isCompact" icon="calendarDisabled" :text="formatDateToLocale(date)" :title="`${eventType}:`" />
          <IconLabel icon="documents" title="Motivo:" :text="optionsDisabled[reason] || reason" class="statusHistoryCard__reason" v-if="reason" />
          <div v-for="(tag, i) in tags" :key="i" class="statusHistoryCard__tag">
            {{ tag.name }}
          </div>
        </div>
        <IconLabel class="statusHistoryCard__description" icon="commentDisabled" title="Detalle:" :text="description" v-if="description" />
        <div class="statusHistoryCard__dateRange" v-if="startDate || endDate">
          <IconLabel icon="calendarDisabled" title="Desde:" :text="$global.dateLocaleFormat(new Date(startDate), { month: '2-digit', day: '2-digit', year: 'numeric' })" />
          <IconLabel icon="calendarDisabled" title="Hasta:" :text="$global.dateLocaleFormat(new Date(endDate), { month: '2-digit', day: '2-digit', year: 'numeric' })" />
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
  .statusHistoryCard {
    width: 100%;
    @include Flex(column, center, flex-start);
    gap: 10px;
    padding: 8px 14px;
    border-radius: $radius-8;
    background-color: #f9f9f9;
    &--green {
      background-color: #f3fff0;
    }
    &--future {
      background-color: #fef2e1;
    }
    &__header {
      width: 100%;
      @include Flex(column, space-between, flex-start);
    }
    &__user {
      @include Flex(row, flex-end, flex-start);
      color: #3d3d3d;
      font-family: $newFont_regular;
      font-weight: 400;
      gap: 5px;
      font-size: 14px;
      min-width: 0;
      flex: 1;
    }
    &__userContainer {
      width: 100%;
      @include Flex(row, space-between);
      gap: 12px;
      overflow: hidden;
    }
    &__iconButton {
      @include Flex();
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      padding: 10px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        background: #e7e7e7;
      }
      &--rotated {
        transform: rotate(-180deg);
        background: #e7e7e7;
        &:hover {
          background: #f9f9f9;
        }
      }
    }

    &__userText {
      width: 80%;
      font-family: $newFont_regular;
    }

    &__userRow {
      @include Flex(row, flex-start, center);
      gap: 10px;
    }

    &__avatar {
      width: 30px;
      height: 30px;
      border: 2px solid $primary_color;
      transition: transform 0.3s ease;
      &:hover {
        transform: scale(1.05);
      }
    }

    &__userIcon {
      @include Flex();
      width: 30px;
      height: 30px;
      border: 2px solid $primary_color;
      border-radius: 50%;
      color: #fff;
      background: #bd0909;
      transition: transform 0.3s ease;
      &:hover {
        transform: scale(1.05);
      }
    }
    &__dateRow {
      @include Flex(row, flex-start, center);
      gap: 5px;
      font-size: 14px;
      margin-top: $space-4;
    }

    &__content {
      @include Flex(column, center, flex-start);
      width: 100%;
      overflow: hidden;
      gap: $space-16;
    }
    &__dateRange {
      @include Flex(column, space-between, flex-start);
      width: 100%;
      gap: 5px;
    }
    &__reason {
      width: auto;
    }
    &__tag {
      @include Flex();
      padding: $space-2 $space-8;
      font-weight: 400;
      font-family: $newFont_regular;
      text-transform: capitalize;
      border-radius: 14px;
      background: #ffe9e9;
    }

    &__contentContainer {
      @include Flex(column, space-between, center);
      width: 100%;
    }

    @media (min-width: 1150px) {
      &__contentContainer,
      &__header,
      &__dateRange {
        flex-direction: row;
      }
      &__userContainer {
        width: 34%;
      }
    }

    &.compact {
      .statusHistoryCard__contentContainer,
      .statusHistoryCard__dateRange {
        @include Flex(column, center, flex-start);
        gap: 3px;
      }
      .statusHistoryCard__dateRange,
      .statusHistoryCard__description {
        margin-top: 3px;
      }

      .statusHistoryCard__content {
        gap: 0;
      }
      .statusHistoryCard__tag {
        margin-left: 18px;
      }
    }
  }
</style>
